"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RAW_UNIT_SUFFIX = exports.setRecipeSchema = exports.recipeLineSchema = exports.adjustRawStockSchema = exports.updateRawItemSchema = exports.createRawItemSchema = exports.RAW_STOCK_MOVEMENT_REASONS = exports.RAW_ITEM_UNITS = void 0;
const zod_1 = require("zod");
/**
 * Wave 3 — raw materials and recipes (SPEC §6.3, owner decision: full recipe
 * system). A product with `trackStock` and a recipe consumes RAW items on
 * sale instead of its own stockQuantity; one with `trackStock` and no recipe
 * decrements its own count as before; one without touches nothing.
 *
 * QUANTITIES ARE INTEGERS in the item's smallest unit (grams, millilitres,
 * pieces) — the same house rule as money. `costMd` is per 1,000 units for
 * G/ML (a kilo, a litre) and per unit for PCS, so integer math never meets a
 * fraction of a dinar on a gram.
 */
exports.RAW_ITEM_UNITS = ['G', 'ML', 'PCS'];
exports.RAW_STOCK_MOVEMENT_REASONS = [
    'OPENING',
    'SALE',
    /** A cafe return put the ingredients back — the Prisma enum's own reason. */
    'SALE_REVERSAL',
    'PURCHASE',
    'WASTAGE',
    'ADJUSTMENT',
];
const rawItemName = zod_1.z.string().trim().min(1, 'Name the item.').max(120);
/** Smallest-unit integer quantity; capped defensively, never fractional. */
const rawQuantity = zod_1.z.number().int().min(0).max(100_000_000);
exports.createRawItemSchema = zod_1.z.object({
    name: rawItemName,
    unit: zod_1.z.enum(exports.RAW_ITEM_UNITS),
    openingQuantity: rawQuantity.default(0),
    /** Per 1,000 units for G/ML, per unit for PCS. Decimal IQD string. */
    costIqd: zod_1.z.number().int().min(0).optional(),
    lowThreshold: rawQuantity.optional(),
});
/** Explicit — never `.partial()` (zod 4 keeps `.default()`s). */
exports.updateRawItemSchema = zod_1.z
    .object({
    name: rawItemName.optional(),
    unit: zod_1.z.enum(exports.RAW_ITEM_UNITS).optional(),
    costIqd: zod_1.z.number().int().min(0).nullable().optional(),
    lowThreshold: rawQuantity.nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nothing to change.' });
exports.adjustRawStockSchema = zod_1.z.object({
    /** Signed smallest-unit delta. */
    delta: zod_1.z
        .number()
        .int()
        .refine((value) => value !== 0, 'A zero adjustment records nothing.'),
    reason: zod_1.z.enum(['PURCHASE', 'WASTAGE', 'ADJUSTMENT']),
    note: zod_1.z.string().trim().max(500).optional(),
});
/* -------------------------------------------------------------------------- */
/* Recipes                                                                    */
/* -------------------------------------------------------------------------- */
exports.recipeLineSchema = zod_1.z.object({
    rawItemId: zod_1.z.string().min(1),
    /** Smallest units consumed PER UNIT of the product sold. */
    quantity: zod_1.z.number().int().min(1).max(1_000_000),
});
/** The whole recipe is replaced atomically — no per-line patching to drift. */
exports.setRecipeSchema = zod_1.z.object({
    lines: zod_1.z.array(exports.recipeLineSchema).max(50),
});
/** Unit → the label shown after a quantity, e.g. "250 g". */
exports.RAW_UNIT_SUFFIX = {
    G: 'g',
    ML: 'ml',
    PCS: 'pcs',
};
//# sourceMappingURL=recipes.js.map